import React from 'react';
import Button from '../../Button';
import Tag from '../Tag';
import './RecommendTag.scss';

const RecommendTag = (props) => {
  const {
    getRecommendTagList,
    summary,
    recommendTagSelectList,
    selectRecommendTag,
    notRecommendListMessage = '추천할 태그가 존재하지 않습니다. ',
  } = props;

  return (
    <div className="select-recommend-tag">
      <Button isRadius color="primary" text="추천 태그 보기" onClick={() => getRecommendTagList()} />

      <div className="summary-text">{summary}</div>

      <div className="select-recommend-tag-list">
        {recommendTagSelectList ? (
          recommendTagSelectList.map((tag) => (
            <Tag key={tag.id} text={tag.name} onClick={() => selectRecommendTag(tag)} />
          ))
        ) : (
          <span className="summary-text">{notRecommendListMessage}</span>
        )}
      </div>
    </div>
  );
};

export default RecommendTag;
